require('./bootstrap');
import Vue from 'vue';
import store from './store';
import router from './routes';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import Toasted from 'vue-toasted';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

Vue.use(Toasted,{
  iconPack : 'fontawesome'
});
Vue.toasted.register('expedium_error',
    (payload) => {
        if(! payload.message) {
    	    return "Something Went Wrong..."
        }
        return payload.message;
    },{
      type : 'error',
      icon : 'error_outline',
      position: 'bottom-center',
      duration: 15000,
    }
);
Vue.toasted.register('expedium_info',
    (payload) => {
        if(! payload.message) {
    	    return "Something Went Wrong..."
        }
        return payload.message;
    },{
      type : 'success',
      position: 'bottom-center',
      duration: 15000,
    }
);

Vue.use(Vuelidate);

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import { BModal, IconsPlugin, BootstrapVue } from 'bootstrap-vue'
Vue.component('b-modal', BModal)

Vue.filter('mapComposante', (value, composante_id) => {
  return value.filter(function (option, index) {
    return option.composante_id == composante_id;
  }).map(function (option, index) {
    return option.groupe_option.libelle+ ' / '
}).join('')
});

const app = new Vue({
    el: '#app',
    store,
    router,
    render: app => app(App),
});
